(function (w, $) {
	'use strict';
	w.dk = w.dk || {};
	$.extend(!0, w.dk, {
		pages: {
			disclaimers: 'https://www.niddk.nih.gov/disclaimers'
		}
	});
})(window, window.jQuery);
